
import React, { useEffect, useState, useRef } from 'react';
import { ErrorMessage, Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  Alert,
  Badge,
  Button,
  CardBody,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from 'reactstrap';
import Obfuscate from 'react-obfuscate';
import Swal from 'sweetalert2';
import ColorNavbar from 'components/Navbars/ColorNavbar.js';
import FullFooter from 'components/Footers/FullFooter.js';
import 'assets/css/react-datepicker.css';

import Cal, { getCalApi } from "@calcom/embed-react";

const validationSchema = Yup.object().shape({
  contactName: Yup.string().required(
    'Name is required.'
  ),
  contactMessage: Yup.string().required(
    'Message is required.'
  ),
  email: Yup.string().email('A valid email is required.').required(
    'Email is required.'
  ),
});


function ContactMe() {

  useEffect(()=>{
    (async function () {
      const cal = await getCalApi();
      cal("ui", {"theme":"dark"});
    })();
  }, []);

  useEffect(
    ()=>{
      document.body.classList.add('contact-page');
      return () => {
        document.body.classList.remove('contact-page');
      }
    },
  []);

  const wrapperRef = useRef(null);
  const [ showSuccessMessage, setShowSuccessMessage] = useState(false);

  const onSubmit = async (values, _) => {
    const contactUrl = 'https://3fkx7jrvak.execute-api.us-east-1.amazonaws.com/prod/contact';
    const {
      email,
      contactName,
      contactMessage,
    } = values;
    let data = {
      email,
      contactName,
      contactMessage,
    };
    fetch(contactUrl, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then(
      response => (response.json())
    ).then(
      (result) => {
        setShowSuccessMessage(true);
      }
    ).catch(
      (err) => {
        console.error(err);
        Swal.fire({
          titleText: 'Error',
          text: err.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        });
      }
    );
  };

  return (
    <>
      <ColorNavbar />
        <div className="wrapper" ref={wrapperRef}>
          <div className="page-header header-filter contactus-3">
            <div
              className="page-header-image"
              style={{
                backgroundImage:
                  "url(" + require("assets/img/roppongi-dusk-to-dark-cropped.jpg").default + ")",
              }}
            />
            <Container>
              <Row>
                <Col className="text-center" md="12">
                  <h1 className="title">Contact Me</h1>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="main">
            <Container fluid>
              <Row className="infos mb-5">
                <Col lg="3">
                  <div className="info info-hover">
                    <div className="icon icon-primary">
                      <img
                        alt="..."
                        className="bg-blob"
                        src={
                          require("assets/img/feature-blob/primary.png").default
                        }
                      />
                      <i className="tim-icons icon-watch-time" />
                    </div>
                    <h4 className="info-title">Time Zone</h4>
                    <p className="description">Eastern Time, North America</p>
                  </div>
                </Col>
                <Col lg="3">
                  <div className="info info-hover">
                    <div className="icon icon-info">
                      <img
                        alt="..."
                        className="bg-blob"
                        src={require("assets/img/feature-blob/info.png").default}
                      />
                      <i className="tim-icons icon-calendar-60" />
                    </div>
                    <h4 className="info-title">Schedule</h4>
                    <p className="description">
                      Mon - Fri, 11:00-16:00
                    </p>
                  </div>
                </Col>
                <Col lg="3">
                  <div className="info info-hover" id="webRtc">
                    <div className="icon icon-warning">
                      <img
                        alt="..."
                        className="bg-blob"
                        src={
                          require("assets/img/feature-blob/warning.png").default
                        }
                      />
                      <i className="tim-icons icon-chat-33" />
                    </div>
                    <h4 className="info-title">WebRTC</h4>
                    <p className="description">Schedule a call</p>
                  </div>
                  <UncontrolledTooltip delay={0} target="webRtc">
                    Use the contact form below.
                  </UncontrolledTooltip>
                </Col>
                <Col lg="3">
                  <div className="info info-hover">
                    <div className="icon icon-success">
                      <img
                        alt="..."
                        className="bg-blob"
                        src={
                          require("assets/img/feature-blob/success.png").default
                        }
                      />
                      <i className="tim-icons icon-single-02" />
                    </div>
                    <h4 className="info-title">Me</h4>
                    <Obfuscate
                      obfuscate={true}
                      element="p"
                      className="description"
                    >
                      James
                    </Obfuscate>
                  </div>
                </Col>
              </Row>

              <Row className="mt-5 mb-4 pt-5">
                <Col className="ml-auto mr-auto text-center mt-5" md="8">
                  {showSuccessMessage ? (
                  <Alert color="success">
                    Your message was sent successfully!
                  </Alert>
                  ) : (
                  <>
                    <h1 className="title">
                      Pick a date and time to schedule a call.
                    </h1>
                    <h4 className="desc">
                      <Badge color="info">OR</Badge> Enter your name, email to send a message. 
                    </h4>
                  </>
                  )}
                </Col>
              </Row>
              <Formik
                enableReinitialize={true}
                initialValues={
                  {
                    contactName: "",
                    email: "",
                    contactMessage: "",
                    appointmentDateTime: "",
                  }
                }
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                >
                <CardBody>
                  <Container>
                    <Row className="justify-content-md-center">
                    <Col>
                        <Row>
                          <Col>
                            <Cal calLink="cloudengineer/30min" style={{width:"100%",height:"100%"}} />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        {!showSuccessMessage && (
                        <Row>
                          <Col className="mx-auto" md="10">
                            <Row>
                              <Col>
                                <FormGroup>
                                  <label>Name</label>
                                  <Input
                                    type="text"
                                    id="contactName"
                                    name="contactName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.contactName}
                                  />
                                  <ErrorMessage
                                    name="contactName"
                                    render={msg => <div className="text-danger">{msg}</div>}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup>
                                <label>Email address</label>
                                <Input
                                  type="text"
                                  id="email"
                                  name="email"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  autoComplete="false"
                                />
                              </FormGroup>
                              <ErrorMessage
                                name="email"
                                render={msg => <div className="text-danger">{msg}</div>}
                              />
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup>
                                  <label>Your message</label>
                                  <Input
                                    id="contactMessage"
                                    name="contactMessage"
                                    rows="6"
                                    type="textarea"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.contactMessage}
                                  />
                                </FormGroup>
                                <ErrorMessage
                                  name="contactMessage"
                                  render={msg => <div className="text-danger">{msg}</div>}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <Button
                                  className="btn-round pull-right"
                                  color="primary"
                                  type="submit"
                                >
                                  <i className="tim-icons icon-email-85"></i>{" "}
                                  Send Message
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </CardBody>
              </Form>
              )}
            </Formik>
            </Container>
          </div>
        <FullFooter />
      </div>
    </>
  );
}

export default ContactMe;
